import { extendableComponent, } from '@graphcommerce/next-ui'
import { PaginationProps, Box, SxProps, Theme, IconButton } from '@mui/material'
import { UsePaginationItem } from '@mui/material/usePagination'
import React from 'react'
import usePagination from './usePagination'
import IconChevronDoubleRight from '../../icons/IconChevronDoubleRight'
import IconChevronRight from '../../icons/IconChevronRight'
import IconChevronLeft from '../../icons/IconChevronLeft'
import IconChevronDoubleLeft from '../../icons/IconChevronDoubleLeft'


export type PagePaginationProps = {
  count: number
  page: number
  renderLink: (page: number, icon: React.ReactNode, btnProps: UsePaginationItem) => React.ReactNode
  sx?: SxProps<Theme>
} & Omit<PaginationProps, 'count' | 'defaultPage' | 'page' | 'renderItem'>

const parts = ['root', 'button', 'icon'] as const
const { classes } = extendableComponent('Pagination', parts)

/**
 * Rel="prev" and rel="next" are deprecated by Google.
 *
 * Read more: https://ahrefs.com/blog/rel-prev-next-pagination/
 */
export function Pagination(props: PagePaginationProps) {
  const { count, page, renderLink, classes: styles, ...paginationProps } = props

  const { items } = usePagination({
    count,
    defaultPage: 1,
    page,
    ...paginationProps,
    siblingCount: 2,
    boundaryCount: 0,
    showFirstButton: true,
    showLastButton: true
  })



  return (
    <Box
      className={classes.root}
      sx={(theme) => ({
        margin: '0',
        display: 'flex',
        direction: 'rtl',
        alignItems: 'center',
        gap: '6px',
        '& .Mui-disabled': {
          background: 'none',
        },
      })}
    >
      <div className='flex gap-1 items-center rtl'>
        {page > 1 && renderLink(page, <IconChevronDoubleRight />, items[0])}

        {page > 1 && renderLink(page, <IconChevronRight />, items[1])}

        {count > 1 ? [...Array(count < 5 ? count : 5).keys()].map((item, index) => (
          <>
            {typeof items[item + 2] !== 'undefined' && items[item + 2] && <div key={index}>
              {renderLink(page, items[item + 2]['page'], items[item + 2])}
            </div>}
          </>

        )) : null}


        {page < count && renderLink(page, <IconChevronLeft />, items[items.length - 2])}

        {page < count && renderLink(page, <IconChevronDoubleLeft />, items[items.length - 1])}
      </div>


    </Box>
  )
}
